import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modern: {
    id: 'core.preferencesDialog.theme.modern',
    defaultMessage: 'Modern theme',
  },
  modernCompact: {
    id: 'core.preferencesDialog.theme.modernCompact',
    defaultMessage: 'Modern compact theme',
  },
  modernCompactBlue: {
    id: 'core.preferencesDialog.theme.modernCompactBlue',
    defaultMessage: 'Modern compact blue theme',
  },
  modernCompactBurgundy: {
    id: 'core.preferencesDialog.theme.modernCompactBurgundy',
    defaultMessage: 'Modern compact Burgundy theme',
  },
  yellowBlue: {
    id: 'core.preferencesDialog.theme.yellowBlue',
    defaultMessage: 'Yellow-blue theme',
  },
  yellowBlueCompact: {
    id: 'core.preferencesDialog.theme.yellowBlueCompact',
    defaultMessage: 'Yellow-blue compact theme',
  },
  rainyDay: {
    id: 'core.preferencesDialog.theme.rainyDay',
    defaultMessage: 'Rainy day theme',
  },
  khaki: {
    id: 'core.preferencesDialog.theme.khaki',
    defaultMessage: 'Khaki theme',
  },
  moonlitSky: {
    id: 'core.preferencesDialog.theme.moonlitSky',
    defaultMessage: 'Moonlit sky dark theme',
  },
  deepOcean: {
    id: 'core.preferencesDialog.theme.deepOcean',
    defaultMessage: 'Deep Ocean (dark)',
  },
  green: {
    id: 'core.preferencesDialog.theme.green',
    defaultMessage: 'Green theme',
  },
});
